export const URL_DATA_ROOT = "https://raw.githubusercontent.com/fduckart/fduckart.github.io/data/latest/";

